// removed by extract-text-webpack-plugin
module.exports = {"trade-slick":"trade-slick","hinghlight-item":"hinghlight-item","slick-next":"slick-next","slick-prev":"slick-prev","slick-arrow":"slick-arrow","slick-disabled":"slick-disabled","trade-category-container":"trade-category-container","trade-left-content":"trade-left-content","title-description":"title-description","title-black":"title-black","view-more-link":"view-more-link","trade-right-content":"trade-right-content","trade-item":"trade-item","trade-name":"trade-name","wrap-image":"wrap-image"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_TradeNewsContainer.scss
// module id = ./components/home/sub-view/_TradeNewsContainer.scss
// module chunks = 0